import React from "react"
import "./Chip.scss"
import { ChipProps } from "../../types"

const Chip: React.FC<ChipProps> = ({ text = "", size = "normal", onClick, textCase, icon, closeIcon, onCloseClick, isSelected }) => {
  const formatText = (text: string) => {
    if (!text) return ""
    if (textCase === "upper") return text.toString().replace(/_/g, " ").toUpperCase()
    if (textCase === "lower") return text.toString().replace(/_/g, " ").toLowerCase()
    if (textCase === "title")
      return text
        .toString()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase())
    return text
  }

  return (
    <div
      className={`chip ${size} ${isSelected ? "selected" : ""}`}
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {icon && <span className="icon">{icon}</span>}
      <span className="text">{formatText(text)}</span>
      {closeIcon && (
        <span
          className="close-icon"
          onClick={(e) => {
            e.stopPropagation()
            onCloseClick?.(e)
          }}
        >
          {closeIcon}
        </span>
      )}
    </div>
  )
}

export default Chip
